<template>
  <div class="immidiate-dashboard-email">
    <div class="container-fluid">
       <div class="row margin-top-3Perc vertical-align">
        <div class="col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Group</b>
            </div> 
            <div class="col-sm-4 col-md-4 col-lg-4" v-if="selectedGroupObjValue === -1">
              <select class="form-control" v-model="selectedGroupObjValue">
                  <option value='-1' disabled>Select</option>
                  <option v-for="groupObj in getGroupListValue" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>             
              </select>
            </div>
            <div class="col-sm-4 col-md-4 col-lg-4" v-else>
              <span class="text-align-left">{{selectedGroupObjValue.GroupName}}</span>
              <span class="glyphicon glyphicon-remove cursor-pointer text-color-red margin-left-5perc text-align-right" @click="clearSelectedAllInputs()"></span>
            </div>
            <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Course</b>
            </div> 
            <div class="col-sm-4 col-md-4 col-lg-4">
                <select class="form-control" v-model="selectedCourseObjValue" :disabled="(selectedGroupObjValue === -1)">
                  <option value='-1' disabled>Select</option>
                  <option v-for="currCourseObj in getCourseListValue" :key="currCourseObj.GroupCourseMasterId" :value="currCourseObj">{{ currCourseObj.CourseTitle + ' [' + currCourseObj.CourseSubTitle + ']'}}</option>
                </select>     
            </div>
            <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-3Perc vertical-align">
          <div class="col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Cohort</b>
          </div> 
          <div class="col-sm-4 col-md-4 col-lg-4">
            <select class="form-control" v-model="selectedCohortObjValue" :disabled="(selectedCourseObjValue === -1)">
              <option value='-1' disabled>Select</option>
              <option v-for="currCohortObj in cohortList" :key="currCohortObj.CohortId" :value="currCohortObj">{{ currCohortObj.CohortName }}</option>
            </select>     
          </div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b></b>
          </div> 
          <div class="col-sm-4 col-md-4 col-lg-4">
          </div>
          <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-3Perc">
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px padding-top-0Point5Perc"> 
            <b>Enrolled Users</b>
          </div>
          <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="border-1px padding-15px text-align-left">
              <div v-if="!showNoUserTxtInEnrolledUserBox" class="margin-bottom-2Perc">
                <u>Total Selected {{selectedEnrolledUserIdArrValue.length > 1 ? 'Users' : 'User' }}:</u> <b>{{selectedEnrolledUserIdArrValue.length}}</b>
              </div>  
              <div v-if="!showNoUserTxtInEnrolledUserBox" class="margin-bottom-2Perc">
                <input type="checkbox" v-model="isSelectedAllEnrolledUserValue" @change="updateEnrollExplicitSelectionFlag"> Select All  
              </div>  
              <div v-for="userObj in enrolledUserListValue" :key="userObj.UserId">
                <input type="checkbox" v-model="selectedEnrolledUserIdArrValue" :value="userObj.UserId"> {{userObj.FirstName + ' ' + userObj.LastName}}
              </div>
              <div v-if="showNoUserTxtInEnrolledUserBox" class="text-align-left">
                No User(s) Found
              </div>
            </div>
          </div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px padding-top-0Point5Perc">
            <b>Unenrolled Users</b>
          </div>
          <div class="col-sm-4 col-md-4 col-lg-4 padding-top-0Point5Perc">
            <div class="border-1px padding-15px text-align-left">
              <div v-if="!showNoUserTxtInUnEnrolledUserBox" class="margin-bottom-2Perc">
                <u>Total Selected {{selectedUnEnrolledUserIdArrValue.length > 1 ? 'Users' : 'User' }}:</u> <b>{{selectedUnEnrolledUserIdArrValue.length}}</b>
              </div>  
              <div v-if="!showNoUserTxtInUnEnrolledUserBox" class="margin-bottom-2Perc">
                <input type="checkbox" v-model="isSelectedAllUnEnrolledUserValue" @change="updateUnEnrollExplicitSelectionFlag"> Select All  
              </div>  
              <div v-for="userObj in unEnrolledUserListValue" :key="userObj.UserId">
                <input type="checkbox" v-model="selectedUnEnrolledUserIdArrValue" :value="userObj.UserId"> {{userObj.FirstName + ' ' + userObj.LastName}}
              </div>
              <div v-if="showNoUserTxtInUnEnrolledUserBox" class="text-align-left">
                No User(s) Found
              </div>
            </div>
          </div>
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-3Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"> 
              <b></b>
           </div>
           <div class="col-sm-9 col-md-9 col-lg-9">
            <button type="button" class="btn btn-default button-orange" @click="addSelectedUsers()" :disabled="(unEnrolledUserListValue.length === 0 && enrolledUserListValue.length === 0)">Add</button>
           </div>
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-3Perc vertical-align" v-if="(selectedGCCUArrValue.length > 0)">
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
            <div class="table-responsive margin-Top-3Perc" >
              <table class="table table-striped ">
                <thead>
                  <tr>
                    <th class="text-align-center font-size-15px border-right">SR. No.</th>
                    <th class="text-align-center font-size-15px border-right">Group</th>
                    <th class="text-align-center font-size-15px border-right">Course</th>
                    <th class="text-align-center font-size-15px border-right">Cohort</th>
                    <th class="text-align-center font-size-15px border-right">Selected Users</th>
                    <th class="text-align-center font-size-15px padding-left-0px padding-right-0px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(currObj, index) in selectedGCCUArrValue" :key="(currObj.groupObj.GroupId + '-' + currObj.courseObj.GroupCourseMasterId + '-' + currObj.cohortObj.CohortId)">
                    <td class="border-right text-align-center col-lg-1">{{(index + 1)}}</td>
                    <td class="border-right text-align-center col-lg-2">{{currObj.groupObj.GroupName}}</td>
                    <td class="border-right text-align-center col-lg-4">{{(currObj.courseObj.CourseTitle + ' [' + currObj.courseObj.CourseSubTitle + ']')}}</td>
                    <td class="border-right text-align-center col-lg-2">{{currObj.cohortObj.CohortName}}</td>
                    <td class="border-right text-align-left col-lg-3" v-html="getFormattedSelectedUserList(currObj.selectedUsersFullName)"></td>
                    <td class="text-align-center col-lg-1 cursor-pointer">
                      <a class="text-decoration-underline" @click="performUserClickAction($event, 'delete_selection', currObj.groupObj, currObj.courseObj, currObj.cohortObj, index)">Delete</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <hr width="94%" size="10px"/>
        <div class="row margin-top-2Perc vertical-align">
           <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-18px">
            <i><u>Who is sending?</u></i>
            </div>
        </div>
        <div class="row margin-top-2Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Name</b>
            </div>
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc Padding-right-0px text-align-left">
                <!-- <input type="text" class="form-control" v-model="senderNameValue"> -->
                {{ senderNameValue }}
              </div>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Email</b>
           </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc Padding-right-0px text-align-left">
                <!-- <input type="text" class="form-control" v-model="senderEmailValue"> -->
                {{ senderEmailValue }}
              </div>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>
        <hr width="94%" size="10px"/>

        <div class="row margin-top-2Perc vertical-align">
           <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-18px">
            <i>Who wants <u>to</u> recieve it?</i>
            </div>
        </div>

        <div class="row margin-top-3Perc vertical-align" v-if="(toEmailsArr.length > 0)">
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
            <div class="table-responsive margin-Top-3Perc" >
              <table class="table table-striped ">
                <thead>
                  <tr>
                    <th class="text-align-center font-size-15px border-right">SR. No.</th>
                    <th class="text-align-center font-size-15px border-right">Name</th>
                    <th class="text-align-center font-size-15px border-right">EmailId</th>
                    <th class="text-align-center font-size-15px padding-left-0px padding-right-0px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(currObj, index) in toEmailsArr" :key="'to_' + index">
                    <td class="border-right text-align-center col-lg-2">{{(index + 1)}}</td>
                    <td class="border-right text-align-center col-lg-4">{{currObj.Name}}</td>
                    <td class="border-right text-align-center col-lg-4">{{currObj.Email}}</td>
                    <td class="text-align-center col-lg-2 cursor-pointer">
                      <a class="text-decoration-underline" @click="performUserClickAction($event, 'delete_to_email_selection', null, null, null, index)">Delete</a>
                    </td>         
                  </tr>
                </tbody>
              </table>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-2Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Name</b>
            </div>
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc Padding-right-0px">
                <input type="text" class="form-control" v-model="toNameValue">
              </div>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Email</b>
           </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc Padding-right-0px">
                <input type="text" class="form-control" v-model="toEmailValue">
              </div>
            </div>
           </div>
           <div class="col-md-1 col-lg-1 text-align-left">
            <span class="glyphicon glyphicon-plus font-size-18px cursor-pointer text-color-green" @click="performUserClickAction($event, 'add_to_emails_details', null, null, null, -1)"></span>            
          </div>
        </div>
        <hr width="94%" size="10px"/>

        <div class="row margin-top-2Perc vertical-align">
           <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-18px">
            <i>Want to send as carbon copy <u>(CC)</u>?</i>
            </div>
        </div>

        <div class="row margin-top-3Perc vertical-align" v-if="(ccEmailArr.length > 0)">
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
            <div class="table-responsive margin-Top-3Perc" >
              <table class="table table-striped ">
                <thead>
                  <tr>
                    <th class="text-align-center font-size-15px border-right">SR. No.</th>
                    <th class="text-align-center font-size-15px border-right">Name</th>
                    <th class="text-align-center font-size-15px border-right">EmailId</th>
                    <th class="text-align-center font-size-15px padding-left-0px padding-right-0px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(currObj, index) in ccEmailArr" :key="'to_' + index">
                    <td class="border-right text-align-center col-lg-2">{{(index + 1)}}</td>
                    <td class="border-right text-align-center col-lg-4">{{currObj.Name}}</td>
                    <td class="border-right text-align-center col-lg-4">{{currObj.Email}}</td>
                    <td class="text-align-center col-lg-2 cursor-pointer">
                      <a class="text-decoration-underline" @click="performUserClickAction($event, 'delete_cc_email_selection', null, null, null, index)">Delete</a>
                    </td>         
                  </tr>
                </tbody>
              </table>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-2Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Name</b>
            </div>
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc Padding-right-0px">
                <input type="text" class="form-control" v-model="ccNameValue">
              </div>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Email</b>
           </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc Padding-right-0px">
                <input type="text" class="form-control" v-model="ccEmailValue">
              </div>
            </div>
           </div>
           <div class="col-md-1 col-lg-1 text-align-left">
            <span class="glyphicon glyphicon-plus cursor-pointer font-size-18px text-color-green" @click="performUserClickAction($event, 'add_cc_emails_details', null, null, null, -1)"></span>            
          </div>
        </div>
        <hr width="94%" size="10px"/>

        <div class="row margin-top-2Perc vertical-align">
           <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-size-18px">
            <i>Want to send as black carbon copy <u>(BCC)</u>?</i>
            </div>
        </div>

        <div class="row margin-top-3Perc vertical-align" v-if="(bccEmailArr.length > 0)">
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
            <div class="table-responsive margin-Top-3Perc" >
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th class="text-align-center font-size-15px border-right">SR. No.</th>
                    <th class="text-align-center font-size-15px border-right">Name</th>
                    <th class="text-align-center font-size-15px border-right">EmailId</th>
                    <th class="text-align-center font-size-15px padding-left-0px padding-right-0px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(currObj, index) in bccEmailArr" :key="'to_' + index">
                    <td class="border-right text-align-center col-lg-2">{{(index + 1)}}</td>
                    <td class="border-right text-align-center col-lg-4">{{currObj.Name}}</td>
                    <td class="border-right text-align-center col-lg-4">{{currObj.Email}}</td>
                    <td class="text-align-center col-lg-2 cursor-pointer">
                      <a class="text-decoration-underline" @click="performUserClickAction($event, 'delete_bcc_email_selection', null, null, null, index)">Delete</a>
                    </td>         
                  </tr>
                </tbody>
              </table>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-2Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Name</b>
            </div>
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc Padding-right-0px">
                <input type="text" class="form-control" v-model="bccNameValue">
              </div>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Email</b>
           </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc Padding-right-0px">
                <input type="text" class="form-control" v-model="bccEmailValue">
              </div>
            </div>
           </div>
           <div class="col-md-1 col-lg-1 text-align-left">
            <span class="glyphicon glyphicon-plus cursor-pointer font-size-18px text-color-green" @click="performUserClickAction($event, 'add_bcc_emails_details', null, null, null, -1)"></span>            
          </div>
        </div>
        <hr width="94%" size="10px"/>

        <div class="row margin-top-3Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Want to Schedule?</b>
            </div> 
           <div class="col-sm-4 col-md-4 col-lg-4 text-align-left">
            <input type="checkbox" v-model="wantToScheduleEmailValue">
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <span v-if="wantToScheduleEmailValue"><b>Frequency</b></span>
           </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
              <select class="form-control" v-model="scheduleReportFrequencyValue" v-if="wantToScheduleEmailValue">
                  <option :value=constants.ReportingTaskFrequency.None disabled>Select</option>
                  <!-- <option :value=constants.ReportingTaskFrequency.Immediate>Immediate</option> -->
                  <option :value=constants.ReportingTaskFrequency.Daily>Daily</option>
                  <option :value=constants.ReportingTaskFrequency.Weekly>Weekly</option>
                  <option :value=constants.ReportingTaskFrequency.Monthly>Monthly</option>
              </select>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-3Perc vertical-align" v-if="wantToScheduleEmailValue">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>StartTs</b>
            </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
            <date-picker v-model="scheduleStartTSValue" :config="config"></date-picker>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>EndTs</b>
           </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
            <date-picker v-model="scheduleEndTSValue" :config="config"></date-picker>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-3Perc vertical-align" v-if="wantToScheduleEmailValue">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Comment</b>
            </div> 
           <div class="col-sm-9 col-md-9 col-lg-9">
            <div class="form-group">
              <textarea class="form-control" rows="3" v-model="scheduleEmailDescValue"></textarea>
            </div>
           </div>
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
        </div>
        <hr width="94%" size="10px"/>

        <div class="row margin-top-3Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Template</b>
            </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
              <select class="form-control" v-model="selectedEmailTemplateValue">
                <option value='-1' disabled>Select</option>
                <option v-for="emailTemplateObj in EmailTemplates" v-bind:key="emailTemplateObj.EmailTemplateId" v-bind:value="emailTemplateObj">{{ emailTemplateObj.EmailTemplateName }}</option>
              </select>     
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Subject</b>
           </div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-10 col-md-10 col-lg-10 text-left Padding-left-0px" :class="{'font-weight-bold': selectedEmailTemplateValue !== -1, 'font-weight-bold-withOpacity75': selectedEmailTemplateValue === -1}">
                  {{selectedEmailTemplateValue === -1 ? 'Template Not Selected' : selectedEmailTemplateValue.EmailSubject}}
              </div>
            </div>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row">
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-md-4 col-lg-4 font-size-14Px margin-top-5px">
            <a class="cursor-pointer" @click="showAddTemplate()">New</a> |
            <a class="cursor-pointer" @click="showUpdateTemplate()">Edit</a> |
            <a class="cursor-pointer" @click="showDeleteTemplateConfirmation()">Delete</a>
          </div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
          </div>
          <div class="col-md-5 col-lg-5">
          </div>
        </div>
        <div class="row margin-top-3Perc">
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class=" col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Content</b>
            </div>
            <div class="col-md-9 col-lg-9">
              <div class="form-group">
                <div class="col-sm-12 text-align-left border-1px-solid-grey padding-2Perc">
                  <span v-html="templateBodyText"></span>
                </div>
                <div class="col-sm-12 padding-left-0Perc Padding-right-0px margin-top-3Perc text-color-blue text-decoration-underline text-align-right cursor-pointer" v-if="(selectedGCCUArrValue.length > 0)">
                  <span @click="performUserClickAction($event, 'preview-template', null, null, null, -1)">Preview Template</span>
                </div>
              </div>
            </div>
        </div>
        <div class="row margin-top-3Perc">
          <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Attach Files</b>
          </div>
          <div class="col-sm-9 col-md-9 col-lg-9">
            <form>
              <div class="row">
                  <div class="col-sm-3 col-md-3 col-lg-3">
                  <input type="file" name="file1" id='file1' accept="image/*">
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3">
                    <input type="file" name="file2" id='file2' accept="image/*">
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3">
                    <input type="file" name="file3" id='file3' accept="image/*">
                  </div>
              </div>
              <div class="row margin-top-2Perc">
                  <div class="col-sm-3 col-md-3 col-lg-3">
                    <input type="file" name="file4" id='file4' accept="image/*">
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3">
                    <input type="file" name="file5" id='file5' accept="image/*">
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3">
                    <input type="file" name="file6" id='file6' accept="image/*">
                  </div>
              </div>
              <div class="row margin-top-3Perc">
                <button type="button" class="btn btn-default button-orange col-lg-offset-4 col-lg-2" @click="wantToScheduleEmailValue ? scheduleDashboardEmail() : sendEmail()" :disabled="(selectedGCCUArrValue.length === 0)">{{wantToScheduleEmailValue ? 'Schedule' : 'Send'}}</button>
              </div>  
            </form>
          </div>
          <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>

        <div class="row margin-top-3Perc vertical-align">
          <div class="col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"><b>Keywords</b></div>
          <div class="col-sm-9 col-md-9 col-lg-9 text-left" v-html="emailDashboardTemplateKeywords"></div>
        </div>

        <div class="row margin-top-3Perc margin-bottom-5Perc">
          <div class="col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"><b>Progress Keyword</b></div>
          <div class="col-sm-9 col-md-9 col-lg-9 text-left">
            <span v-html="emailDashboardProgressKeywords"></span>
            <br><br>
            <span v-html="emailDashboardTemplateHelpTip"></span>
          </div>
        </div>
    </div>
    <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
    </div>
    <loader></loader>
    <preview-dashboard-email-template v-if="showPreviewOriginalDashboardEmailTemplate" :serverResp="originalDashboardEmailTemplateResp" :selectedEmailTemplate="selectedEmailTemplateValue" @closeOverlay="closeTemplateOverlay"></preview-dashboard-email-template>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixTemplateString" v-bind:postfixString="postTemplateString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performPostApprovalActions"></confirmation-alert>
    <add-template-overlay v-if="showAddTemplateOverlay" v-bind:templateType=2 @closeOverlay="closeTemplateOverlay"></add-template-overlay>
    <update-template-overlay v-bind:selectedTemplateObj="selectedEmailTemplateValue" v-if="showUpdateTemplateOverlay" @closeOverlay="closeTemplateOverlay" @isUpdatedTemplate="isUpdateSelectedTemplate"></update-template-overlay>       
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>     
    </div>
</template>

<script>
import AddTemplateOverlay from '@/components/emails/template/AddTemplateOverlay'
import UpdateTemplateOverlay from '@/components/emails/template/UpdateTemplateOverlay'
import PreviewDashboardEmailTemplate from '@/components/emails/dashboard_emails/PreviewDashboardEmailTemplate'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { constants } from '@/utils/constants'
import { VueEditor } from 'vue2-quill-editor'
import { groupService } from '@/server-util/group-service'
import { cohortService } from '@/server-util/cohort-service'
import { groupCourseService } from '@/server-util/group-course-service'
import { emailService } from '@/server-util/email-service'
import { templateService } from '@/server-util/template-service'
import Loader from '@/components/dashboard/Loader'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import {forEach, find, findIndex, filter, concat} from 'lodash'
import datePicker from 'vue-bootstrap-datetimepicker'
export default {
  data: function () {
    return {
      constants: constants,
      emailDashboardTemplateKeywords: '{firstname}, {lastname}, {email}, {loginid}',
      emailDashboardProgressKeywords: '{StartTable}, {CourseImage}, {CourseName:label_CourseName}, Participants:Participants}, {LoggedIn:LoggedIn}, {Engaged:Engaged}, {Range:80,50-79,20-49,1-19,0}, {EndTable}',
      emailDashboardTemplateHelpTip: '- Instead of Specifiy a range, If you mention a single number in the template then records will be fetch for that particular percentage only.<br/>- If you want progress such as <b>X%-above</b> then replace <b>X%</b> with the actual lower limit and <b>above</b> with upper limit.<br/>&nbsp;&nbsp;For eg: <b>{Range:80,50-79,20-49,1-19,0}</b> or <b>{Range:80-100,50-79,20-49,1-19,0}</b> etc.',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      userList: [],
      groupList: [],
      coursesList: [],
      cohortList: [],
      selectedGroupObj: -1,
      selectedCourseObj: -1,
      selectedCohortObj: -1,
      showNoUserTxtInEnrolledUserBox: true,
      showNoUserTxtInUnEnrolledUserBox: true,
      isSelectedAllUnEnrolledUser: false,
      isSelectedAllEnrolledUser: false,
      selectedEnrolledUserIdArr: [],
      selectedUnEnrolledUserIdArr: [],
      selectedGCCUArr: [],
      senderObj: {
        Name: '',
        Email: ''
      },
      toEmailObj: {
        Name: '',
        Email: ''
      },
      ccEmailObj: {
        Name: '',
        Email: ''
      },
      bccEmailObj: {
        Name: '',
        Email: ''
      },
      toEmailsArr: [],
      ccEmailArr: [],
      bccEmailArr: [],
      selectedCourseIds: [],
      selectedUserIds: [],
      senderEmails: [],
      selectedEmailTemplate: -1,
      templateBodyText: 'Template Not Selected',
      prefixTemplateString: 'Are you sure you want to delete ',
      postTemplateString: '',
      showConfirmationBox: false,
      showAddTemplateOverlay: false,
      showUpdateTemplateOverlay: false,
      showPreviewOriginalDashboardEmailTemplate: false,
      originalDashboardEmailTemplateResp: null,
      sendOrScheduledEmailSuccessfully: false,
      wantToScheduleEmail: false,
      scheduleStartTS: new Date(),
      scheduleEndTS: new Date(),
      scheduleReportFrequency: -1,
      config: {
        format: 'MM/DD/YYYY h:mm:ss A',
        defaultDate: new Date(),
        useCurrent: true,
        sideBySide: true
      },
      scheduleEmailDesc: ''
    }
  },
  created: function () {
    this.setDefaultValues()
    this.getCurrentTemplateList()
    this.getGroups()
  },
  components: {
    'alert-box': AlertBox,
    VueEditor,
    'add-template-overlay': AddTemplateOverlay,
    'update-template-overlay': UpdateTemplateOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader,
    'date-picker': datePicker,
    'preview-dashboard-email-template': PreviewDashboardEmailTemplate
  },
  computed: {
    scheduleEmailDescValue: {
      get: function () {
        return this.scheduleEmailDesc
      },
      set: function (newValue) {
        this.scheduleEmailDesc = newValue
      }
    },
    scheduleStartTSValue: {
      get: function () {
        return this.scheduleStartTS
      },
      set: function (newValue) {
        this.scheduleStartTS = newValue
      }
    },
    scheduleEndTSValue: {
      get: function () {
        return this.scheduleEndTS
      },
      set: function (newValue) {
        this.scheduleEndTS = newValue
      }
    },
    scheduleReportFrequencyValue: {
      get: function () {
        return this.scheduleReportFrequency
      },
      set: function (newValue) {
        this.scheduleReportFrequency = parseInt(newValue)
      }
    },
    wantToScheduleEmailValue: {
      get: function () {
        return this.wantToScheduleEmail
      },
      set: function (newValue) {
        this.wantToScheduleEmail = newValue
        if (newValue) {
          this.scheduleStartTSValue = dmAdminUtils.getCurrentEst(0, 0, 0)
          this.scheduleEndTSValue = dmAdminUtils.getCurrentEst(1, 0, 0)
          this.scheduleReportFrequencyValue = constants.ReportingTaskFrequency.None
          this.scheduleEmailDescValue = ''
        }
      }
    },
    senderObjValue: {
      get: function () {
        return this.senderObj
      },
      set: function (newValue) {
        this.senderObj = newValue
      }
    },
    senderNameValue: {
      get: function () {
        return this.senderObj.Name
      },
      set: function (newValue) {
        this.senderObj.Name = newValue
      }
    },
    senderEmailValue: {
      get: function () {
        return this.senderObj.Email
      },
      set: function (newValue) {
        this.senderObj.Email = newValue
      }
    },
    toEmailObjValue: {
      get: function () {
        return this.toEmailObj
      },
      set: function (newValue) {
        this.toEmailObj = newValue
      }
    },
    toNameValue: {
      get: function () {
        return this.toEmailObjValue.Name
      },
      set: function (newValue) {
        this.toEmailObjValue.Name = newValue
      }
    },
    toEmailValue: {
      get: function () {
        return this.toEmailObjValue.Email
      },
      set: function (newValue) {
        this.toEmailObjValue.Email = newValue
      }
    },
    ccEmailObjValue: {
      get: function () {
        return this.ccEmailObj
      },
      set: function (newValue) {
        this.ccEmailObj = newValue
      }
    },
    ccNameValue: {
      get: function () {
        return this.ccEmailObjValue.Name
      },
      set: function (newValue) {
        this.ccEmailObjValue.Name = newValue
      }
    },
    ccEmailValue: {
      get: function () {
        return this.ccEmailObjValue.Email
      },
      set: function (newValue) {
        this.ccEmailObjValue.Email = newValue
      }
    },
    bccEmailObjValue: {
      get: function () {
        return this.bccEmailObj
      },
      set: function (newValue) {
        this.bccEmailObj = newValue
      }
    },
    bccNameValue: {
      get: function () {
        return this.bccEmailObjValue.Name
      },
      set: function (newValue) {
        this.bccEmailObjValue.Name = newValue
      }
    },
    bccEmailValue: {
      get: function () {
        return this.bccEmailObjValue.Email
      },
      set: function (newValue) {
        this.bccEmailObjValue.Email = newValue
      }
    },
    selectedCohortObjValue: {
      get: function () {
        return this.selectedCohortObj
      },
      set: function (newValue) {
        this.selectedCohortObj = newValue
        this.userListValue = []
        this.showNoUserTxtInEnrolledUserBox = true
        this.showNoUserTxtInUnEnrolledUserBox = true
        this.isSelectedAllUnEnrolledUserValue = false
        this.isSelectedAllEnrolledUserValue = false
        this.selectedEnrolledUserIdArr = []
        this.selectedUnEnrolledUserIdArr = []
        if (this.selectedCohortObj !== -1) {
          this.getAssociatedUserList()
        }
      }
    },
    selectedCourseObjValue: {
      get: function () {
        return this.selectedCourseObj
      },
      set: function (newValue) {
        this.selectedCourseObj = newValue
        this.cohortList = []
        this.selectedCohortObjValue = -1
        this.userListValue = []
        this.showNoUserTxtInEnrolledUserBox = true
        this.showNoUserTxtInUnEnrolledUserBox = true
        this.isSelectedAllUnEnrolledUserValue = false
        this.isSelectedAllEnrolledUserValue = false
        this.selectedEnrolledUserIdArr = []
        this.selectedUnEnrolledUserIdArr = []
        if (this.selectedCourseObj !== -1) {
          this.getAssociatedCohortList()
        }
      }
    },
    selectedGroupObjValue: {
      get: function () {
        return this.selectedGroupObj
      },
      set: function (newValue) {
        this.selectedGroupObj = newValue
        this.selectedCourseObjValue = -1
        this.selectedCohortObjValue = -1
        this.userListValue = []
        this.showNoUserTxtInEnrolledUserBox = true
        this.showNoUserTxtInUnEnrolledUserBox = true
        this.isSelectedAllUnEnrolledUserValue = false
        this.isSelectedAllEnrolledUserValue = false
        this.selectedEnrolledUserIdArr = []
        this.selectedUnEnrolledUserIdArr = []
        if (this.selectedGroupObj !== -1) {
          this.getGroupCourses()
        }
      }
    },
    userListValue: {
      get: function () {
        return this.userList
      },
      set: function (newValue) {
        this.userList = newValue
      }
    },
    enrolledUserListValue: {
      get: function () {
        return filter(this.userList, (obj) => {
          return !obj.Unenrolled
        })
      }
    },
    unEnrolledUserListValue: {
      get: function () {
        return filter(this.userList, (obj) => {
          return obj.Unenrolled
        })
      }
    },
    selectedUnEnrolledUserIdArrValue: {
      get: function () {
        return this.selectedUnEnrolledUserIdArr
      },
      set: function (newValue) {
        this.selectedUnEnrolledUserIdArr = newValue
        this.isSelectedAllUnEnrolledUser = (this.selectedUnEnrolledUserIdArr.length > 0 && this.unEnrolledUserListValue.length === this.selectedUnEnrolledUserIdArr.length)
      }
    },
    selectedEnrolledUserIdArrValue: {
      get: function () {
        return this.selectedEnrolledUserIdArr
      },
      set: function (newValue) {
        this.selectedEnrolledUserIdArr = newValue
        this.isSelectedAllEnrolledUser = (this.selectedEnrolledUserIdArr.length > 0 && this.enrolledUserListValue.length === this.selectedEnrolledUserIdArr.length)
      }
    },
    isSelectedAllUnEnrolledUserValue: {
      get: function () {
        return this.isSelectedAllUnEnrolledUser
      },
      set: function (newValue) {
        this.isSelectedAllUnEnrolledUser = newValue
        this.selectedUnEnrolledUserIdArr = []
        if (newValue) {
          this.selectedUnEnrolledUserIdArr = []
          for (var i = 0; i < this.userListValue.length; i++) {
            if (this.userListValue[i].Unenrolled) {
              this.selectedUnEnrolledUserIdArr.push(this.userListValue[i].UserId)
            }
          }
        }
      }
    },
    isSelectedAllEnrolledUserValue: {
      get: function () {
        return this.isSelectedAllEnrolledUser
      },
      set: function (newValue) {
        this.isSelectedAllEnrolledUser = newValue
        this.selectedEnrolledUserIdArr = []
        if (newValue) {
          this.selectedEnrolledUserIdArr = []
          for (var i = 0; i < this.userListValue.length; i++) {
            if (!this.userListValue[i].Unenrolled) {
              this.selectedEnrolledUserIdArr.push(this.userListValue[i].UserId)
            }
          }
        }
      }
    },
    selectedGCCUArrValue: {
      get: function () {
        return this.selectedGCCUArr
      },
      set: function (newValue) {
        this.selectedGCCUArr = newValue
      }
    },
    selectedEmailTemplateValue: {
      get: function () {
        return this.selectedEmailTemplate
      },
      set: function (newValue) {
        this.selectedEmailTemplate = newValue
        if (this.selectedEmailTemplate !== -1) {
          this.getSelectedEmailTemplate()
        }
      }
    },
    getGroupListValue: {
      get: function () {
        return this.groupList
      },
      set: function (newValue) {
        this.groupList = newValue
      }
    },
    getCourseListValue: {
      get: function () {
        return this.coursesList
      },
      set: function (newValue) {
        this.coursesList = newValue
      }
    },
    EmailTemplates: {
      get: function () {
        return this.$store.state.emailDashboardTemplateList
      },
      set: function (newValue) {
        this.$store.state.emailDashboardTemplateList = newValue
      }
    }
  },
  methods: {
    setDefaultValues: function () {
      this.userObj = this.$store.state.curr_user
      this.scheduleStartTS = dmAdminUtils.getCurrentEst(0, 0, 0)
      this.scheduleEndTS = dmAdminUtils.getCurrentEst(1, 0, 0)
      this.senderNameValue = this.userObj.FirstName + ' ' + this.userObj.LastName
      this.senderEmailValue = this.userObj.Email
    },
    getFormattedSelectedUserList: function (fullNameList) {
      var htmlStrToReturn = '<span>'
      forEach(fullNameList, (currentName, index) => {
        htmlStrToReturn += (index + 1) + '. ' + currentName + '<br/>'
      })
      htmlStrToReturn += '</span>'
      return htmlStrToReturn
    },
    clearSelectedAllInputs: function () {
      this.showConfirmationBox = true
      this.prefixTemplateString = 'Changing current group will clear '
      this.postTemplateString = 'all entered inputs hence Do you want to reset it?'
    },
    validateEmail: function (emailId) {
      /* eslint-disable */
      var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      /* eslint-enable */
      if (!(emailId !== undefined && emailId !== 'undefined' && emailId !== null && emailId !== 'null' && emailId.length !== 0)) {
        this.showAlertDialog = true
        this.errorMsg = 'Email address can\'t be empty.'
        return false
      } else if (!mailformat.test(emailId)) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid email address provided.'
        return false
      }
      return true
    },
    performUserClickAction: function (event, operationName, groupObj, courseObj, cohortObj, indexToDelete) {
      switch (operationName) {
        case 'delete_to_email_selection':
          if (indexToDelete > -1) {
            this.toEmailsArr.splice(indexToDelete, 1)
          }
          break
        case 'delete_cc_email_selection':
          if (indexToDelete > -1) {
            this.ccEmailArr.splice(indexToDelete, 1)
          }
          break
        case 'delete_bcc_email_selection':
          if (indexToDelete > -1) {
            this.bccEmailArr.splice(indexToDelete, 1)
          }
          break
        case 'delete_selection':
          if (indexToDelete > -1) {
            this.selectedGCCUArrValue.splice(indexToDelete, 1)
          }
          break
        case 'add_to_emails_details':
          if (this.validateEmail(this.toEmailValue)) {
            var objToPush = {
              Name: (this.toNameValue !== undefined && this.toNameValue !== 'undefined' && this.toNameValue !== null && this.toNameValue !== 'null' && this.toNameValue.length !== 0) ? this.toNameValue : null,
              Email: this.toEmailValue
            }
            this.toEmailsArr.push(objToPush)
            this.toNameValue = ''
            this.toEmailValue = ''
          }
          break
        case 'add_cc_emails_details':
          if (this.validateEmail(this.ccEmailValue)) {
            objToPush = {
              Name: (this.ccNameValue !== undefined && this.ccNameValue !== 'undefined' && this.ccNameValue !== null && this.ccNameValue !== 'null' && this.ccNameValue.length !== 0) ? this.ccNameValue : null,
              Email: this.ccEmailValue
            }
            this.ccEmailArr.push(objToPush)
            this.ccNameValue = ''
            this.ccEmailValue = ''
          }
          break
        case 'add_bcc_emails_details':
          if (this.validateEmail(this.bccEmailValue)) {
            objToPush = {
              Name: (this.bccNameValue !== undefined && this.bccNameValue !== 'undefined' && this.bccNameValue !== null && this.bccNameValue !== 'null' && this.bccNameValue.length !== 0) ? this.bccNameValue : null,
              Email: this.bccEmailValue
            }
            this.bccEmailArr.push(objToPush)
            this.bccNameValue = ''
            this.bccEmailValue = ''
          }
          break
        case 'preview-template':
          this.originalDashboardEmailTemplateResp = null
          if (this.validateRequiredFieldBeforeSubmit(false)) {
            this.previewDashboardTemplateBeforeSendOrSchedule()
          }
          break
      }
    },
    previewDashboardTemplateBeforeSendOrSchedule: function () {
      var _this = this
      var storeObj = this.$store
      var objToPost = {
        TemplateId: this.selectedEmailTemplate.EmailTemplateId,
        GroupData: this.getGCCDataObj(),
        ToEmails: JSON.stringify(this.toEmailsArr),
        EmailCcs: JSON.stringify(this.ccEmailArr),
        EmailBccs: JSON.stringify(this.bccEmailArr)
      }
      _this.$store.state.isLoading = true
      emailService.previewEmailBeforeSendDashboardEmail(storeObj.state.access_token, objToPost).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          _this.$store.state.isLoading = false
          _this.showPreviewOriginalDashboardEmailTemplate = true
          _this.$store.state.isOverlayVisible = true
          _this.originalDashboardEmailTemplateResp = responseObj.data
        } else {
          _this.showAlertDialog = true
          _this.errorMsg = 'Oops! Something went wrong. Please try again.'
          // AK: Hide Spinner if error occured
          _this.$store.state.isLoading = false
        }
      }, errorObj => {
        _this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    addSelectedUsers: function () {
      if (this.selectedEnrolledUserIdArr.length === 0 && this.selectedUnEnrolledUserIdArr.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one participant to Add'
      } else {
        const foundObj = find(this.selectedGCCUArrValue, (currObj) => {
          return (this.selectedGroupObj.GroupId === currObj.groupObj.GroupId && this.selectedCourseObj.GroupCourseMasterId === currObj.courseObj.GroupCourseMasterId && this.selectedCohortObj.CohortId === currObj.cohortObj.CohortId)
        })
        if (this.selectedGCCUArrValue.length > 0 && (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '')) {
          this.showAlertDialog = true
          this.errorMsg = 'Selected group course cohort entry is already present in the list. Kindly Delete existing and then try again'
        } else {
          const combinedUserIdList = concat(this.selectedEnrolledUserIdArrValue, this.selectedUnEnrolledUserIdArrValue)
          var objToPush = {
            groupObj: this.selectedGroupObj,
            courseObj: this.selectedCourseObj,
            cohortObj: this.selectedCohortObj,
            userIds: combinedUserIdList,
            selectedUsersFullName: this.getSelectedUsersName(combinedUserIdList)
          }
          this.selectedGCCUArrValue.push(objToPush)
          // AK: Reset all upper part value to except group and course state
          this.selectedCohortObjValue = -1
        }
      }
    },
    getSelectedUsersName: function (combinedUserIdList) {
      const arrToReturn = []
      forEach(combinedUserIdList, (currUserId) => {
        const foundObj = find(this.userListValue, (currUserObj) => {
          return currUserObj.UserId === currUserId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          var strToPush = foundObj.FirstName + ' ' + foundObj.LastName
          arrToReturn.push(strToPush)
        }
      })
      return arrToReturn
    },
    updateUnEnrollExplicitSelectionFlag: function () {
      this.selectedUnEnrolledUserIdArr = []
      if (this.isSelectedAllUnEnrolledUser) {
        this.selectedUnEnrolledUserIdArr = []
        for (var i = 0; i < this.userListValue.length; i++) {
          if (this.userListValue[i].Unenrolled) {
            this.selectedUnEnrolledUserIdArr.push(this.userListValue[i].UserId)
          }
        }
      }
    },
    updateEnrollExplicitSelectionFlag: function () {
      this.selectedEnrolledUserIdArr = []
      if (this.isSelectedAllEnrolledUser) {
        this.selectedEnrolledUserIdArr = []
        for (var i = 0; i < this.userListValue.length; i++) {
          if (!this.userListValue[i].Unenrolled) {
            this.selectedEnrolledUserIdArr.push(this.userListValue[i].UserId)
          }
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.sendOrScheduledEmailSuccessfully) {
        this.clearAllFields()
      }
    },
    showAddTemplate: function () {
      this.showAddTemplateOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    showUpdateTemplate () {
      if (this.selectedEmailTemplateValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
        return
      }
      this.showUpdateTemplateOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    showDeleteTemplateConfirmation () {
      if (this.selectedEmailTemplateValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
        return
      }
      this.showConfirmationBox = true
      this.$store.state.isOverlayVisible = true
      this.postTemplateString = '\'' + this.selectedEmailTemplateValue.EmailTemplateName + '\' template?'
    },
    closeTemplateOverlay () {
      this.$store.state.isOverlayVisible = false
      if (this.showAddTemplateOverlay) {
        this.showAddTemplateOverlay = false
      }
      if (this.showUpdateTemplateOverlay) {
        this.showUpdateTemplateOverlay = false
      }
      if (this.showPreviewOriginalDashboardEmailTemplate) {
        this.showPreviewOriginalDashboardEmailTemplate = false
      }
      if (this.selectedEmailTemplateValue !== -1) {
        this.getSelectedEmailTemplate()
      }
    },
    isUpdateSelectedTemplate (value) {
      // AK: Used to reset template filter to -1 if user updated any Template
      if (value) {
        this.selectedEmailTemplate = -1
        this.templateBodyText = 'Template Not Selected'
      }
    },
    performPostApprovalActions (value) {
      this.$store.state.isOverlayVisible = false
      this.showConfirmationBox = false
      // AK: Used to delete selected Template
      if (value) {
        if (this.postTemplateString === 'all entered inputs hence Do you want to reset it?') {
          this.clearAllFields()
        } else {
          this.deleteTemplate()
        }
      }
    },
    deleteTemplate: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedEmailTemplateValue !== -1) {
        this.$store.state.isLoading = true
        templateService
          .deleteTemplate(
            storeObj.state.access_token, this.selectedEmailTemplateValue.EmailTemplateId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.selectedEmailTemplateValue = -1
              const foundIndex = findIndex(storeObj.state.emailDashboardTemplateList, (currObj) => {
                return currObj.EmailTemplateId === this.selectedEmailTemplateValue.EmailTemplateId
              })
              if (foundIndex > -1) {
                storeObj.state.emailDashboardTemplateList.splice(foundIndex, 1)
              }
              this.$store.state.isLoading = false
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            _this.showAlertDialog = true
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            if (errorObj.response === undefined) {
              _this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              _this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('TEMPLATE OBJECT IS NULL HENCE DECLINED DELETE TEMPALTE OPERATION.')
      }
    },
    updateShowConfirmationAlertFlag (value) {
      this.$store.state.isOverlayVisible = false
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    getGroups: function () {
      var store = this.$store
      var _this = this
      this.getGroupListValue = store.state.groupList
      if (store.state.groupList.length === 0) {
        _this.$store.state.isLoading = true
      }
      groupService.listGroups(store.state.access_token).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          store.state.groupList = responseObj.data
          _this.getGroupListValue = responseObj.data
          _this.$store.state.isLoading = false
        } else {
          _this.showAlertDialog = true
          _this.errorMsg = 'Oops! Something went wrong. Please try again.'
          _this.$store.state.isLoading = false
        }
      }, errorObj => {
        // AK: Hide Spinner if error occured
        _this.$store.state.isLoading = false
        _this.showAlertDialog = true
        if (errorObj.response === undefined) {
          _this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          _this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getGroupCourses: function () {
      var _this = this
      var store = this.$store
      this.$store.state.isLoading = true
      groupCourseService.listGroupCoursesMaster(store.state.access_token, this.selectedGroupObj.GroupId).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          _this.getCourseListValue = responseObj.data
        }
      }, errorObj => {
        // _this.showSpinner = false
        _this.$store.state.isLoading = false
        _this.showAlertDialog = true
        if (errorObj.response === undefined) {
          _this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          _this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCourseObjValue !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedCourseObjValue.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedCourseObjValue.CourseSubTitle === null ? '' : ' [' + this.selectedCourseObjValue.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedCourseObjValue.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.cohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAssociatedUserList () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCohortObj.CohortId !== undefined
      ) {
        _this.$store.state.isLoading = true
        cohortService
          .getParticipantList(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId,
            this.selectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.errorMsg = 'No user found in \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showAlertDialog = true
              }
              this.userList = responseObj.data
              this.showNoUserTxtInEnrolledUserBox = (this.enrolledUserListValue.length === 0)
              this.showNoUserTxtInUnEnrolledUserBox = (this.unEnrolledUserListValue.length === 0)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'CohortId is NULL hence declined GET PARTICIPANT LIST OPERATION'
        )
      }
    },
    getCurrentTemplateList: function () {
      var store = this.$store
      var _this = this
      var token = store.state.access_token

      store.state.emailDashboardTemplateList = []
      emailService.getTemplateList(token, constants.EmailTemplateType.Dashboard_Email).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          _this.$store.state.isLoading = false
          store.state.emailDashboardTemplateList = responseObj.data
          _this.EmailTemplates = store.state.emailDashboardTemplateList
          // AK: Close overlay
          _this.$emit('closeOverlay', false)
        }
      }, errorObj => {
        _this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getSelectedEmailTemplate: function () {
      var store = this.$store
      var token = store.state.access_token
      emailService.getTemplateText(token, this.selectedEmailTemplate.EmailTemplateId).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          this.$store.state.isLoading = false
          this.templateBodyText = responseObj.data.EmailTemplateText
          const orgContent = dmAdminUtils.removeTFromUrls(this.templateBodyText)
          this.templateBodyText = orgContent
          this.selectedEmailTemplate.EmailTemplateText = responseObj.data.EmailTemplateText
          const index = findIndex(this.EmailTemplates, {EmailTemplateId: this.selectedEmailTemplate.EmailTemplateId})
          if (index) {
            this.EmailTemplates[index].EmailTemplateText = responseObj.data.EmailTemplateText
          }
        }
      }, errorObj => {
        this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    validateRequiredFieldBeforeSubmit: function (checkSenderDetails) {
      if (this.selectedGCCUArrValue.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one participant either from Enrolled or Unenrolled list.'
        return false
      } else if (checkSenderDetails && this.senderObj.Name.trim().length === 0 && this.senderObj.Email.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add sender details.'
        return false
      } else if (checkSenderDetails && (this.toEmailsArr.length === 0 && this.ccEmailArr.length === 0 && this.bccEmailArr.length === 0)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add atleast one recipient in To/CC/BCC.'
        return false
      } else if (this.selectedEmailTemplate === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an email template.'
        return
      }
      return true
    },
    getGCCDataObj: function () {
      var objToReturn = {
        GroupId: this.selectedGroupObj.GroupId,
        GCCData: []
      }
      forEach(this.selectedGCCUArrValue, (obj) => {
        var childObj = {
          GroupCourseMasterId: obj.courseObj.GroupCourseMasterId,
          CourseMasterId: obj.courseObj.CourseMasterId,
          CohortIds: obj.cohortObj.CohortId,
          UserIds: obj.userIds
        }
        objToReturn.GCCData.push(childObj)
      })
      return objToReturn
    },
    sendEmail: function () {
      if (this.validateRequiredFieldBeforeSubmit(true)) {
        var _this = this
        _this.sendOrScheduledEmailSuccessfully = false
        var store = this.$store
        var token = store.state.access_token
        const formData = new FormData()
        formData.append('ToEmails', JSON.stringify(this.toEmailsArr))
        formData.append('EmailTemplateId', this.selectedEmailTemplate.EmailTemplateId)
        formData.append('SenderEmail', JSON.stringify(this.senderObj))
        formData.append('EmailCcs', JSON.stringify(this.ccEmailArr))
        formData.append('EmailBccs', JSON.stringify(this.bccEmailArr))
        formData.append('ReportType', 116)
        formData.append('GroupData', JSON.stringify(this.getGCCDataObj()))

        var file1 = document.getElementById('file1').files[0]
        var file2 = document.getElementById('file2').files[0]
        var file3 = document.getElementById('file3').files[0]
        var file4 = document.getElementById('file4').files[0]
        var file5 = document.getElementById('file5').files[0]
        var file6 = document.getElementById('file6').files[0]
        if (file1 !== undefined) {
          formData.append('file1', file1)
        }
        if (file2 !== undefined) {
          formData.append('file2', file2)
        }
        if (file3 !== undefined) {
          formData.append('file3', file3)
        }
        if (file4 !== undefined) {
          formData.append('file4', file4)
        }
        if (file5 !== undefined) {
          formData.append('file5', file5)
        }
        if (file6 !== undefined) {
          formData.append('file6', file6)
        }
        this.$store.state.isLoading = true
        emailService.sendEmailDashboardMail(token, formData).then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            _this.$store.state.isLoading = false
            _this.showAlertDialog = true
            _this.errorMsg = 'Total Users: <b>' + responseObj.data.TotalUsers + '</b><br/>' + 'Total Emails Sent: <b>' + responseObj.data.TotalEmailsSent + '</b><br/>' + 'Total Emails Failed: <b>' + responseObj.data.FailedEmailList.length + '</b>'
            if (responseObj.data.FailedEmailList.length > 0) {
              _this.errorMsg += '<br/>Failed Email Id(s):<br/>'
              forEach(responseObj.data.FailedEmailList, (emailId, index) => {
                _this.errorMsg += (index + 1) + '. ' + emailId + '<br/>'
              })
            }
            _this.sendOrScheduledEmailSuccessfully = true
          } else {
            _this.sendOrScheduledEmailSuccessfully = false
            _this.showAlertDialog = true
            _this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          _this.$store.state.isLoading = false
          _this.sendOrScheduledEmailSuccessfully = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
      }
    },
    validateRequiredFieldBeforeSchedule: function () {
      if (this.selectedGCCUArrValue.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one participant either from Enrolled or Unenrolled list.'
        return false
      } else if (this.scheduleReportFrequencyValue === constants.ReportingTaskFrequency.None) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a email frequency.'
        return false
      } else if (this.scheduleStartTSValue === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a start time.'
        return
      } else if (this.scheduleEndTSValue === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an end time.'
        return
      } else if (Date.parse(this.scheduleStartTSValue) > Date.parse(this.scheduleEndTSValue)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start time must be less than the end time.'
        return
      } else if (this.senderObj.Name.trim().length === 0 && this.senderObj.Email.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add sender details.'
        return false
      } else if ((this.toEmailsArr.length === 0 && this.ccEmailArr.length === 0 && this.bccEmailArr.length === 0)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add atleast one recipient in To/CC/BCC.'
        return false
      } else if (this.selectedEmailTemplate === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an email template.'
        return
      }
      return true
    },
    scheduleDashboardEmail: function () {
      if (this.validateRequiredFieldBeforeSchedule()) {
        var _this = this
        const userObj = this.$store.state.curr_user
        const authorName = (userObj !== undefined && userObj !== 'undefined' && userObj !== null && userObj !== 'null' && userObj !== '') ? userObj.FirstName + ' ' + userObj.LastName : 'Anonymous User'
        _this.sendOrScheduledEmailSuccessfully = false
        var store = this.$store
        var token = store.state.access_token
        const formData = new FormData()
        formData.append('ToEmails', JSON.stringify(this.toEmailsArr))
        formData.append('Description', (this.scheduleEmailDescValue !== undefined && this.scheduleEmailDescValue !== 'undefined' && this.scheduleEmailDescValue !== null && this.scheduleEmailDescValue !== 'null' && this.scheduleEmailDescValue !== '') ? this.scheduleEmailDescValue : null)
        formData.append('Author', authorName)
        formData.append('Frequency', this.scheduleReportFrequency)
        formData.append('EmailTemplateId', this.selectedEmailTemplate.EmailTemplateId)
        formData.append('SenderEmail', JSON.stringify(this.senderObj))
        formData.append('EmailCcs', JSON.stringify(this.ccEmailArr))
        formData.append('EmailBccs', JSON.stringify(this.bccEmailArr))
        formData.append('EndTs', this.scheduleEndTSValue)
        formData.append('StartTs', this.scheduleStartTSValue)
        formData.append('ReportType', 116)
        formData.append('GroupData', JSON.stringify(this.getGCCDataObj()))

        var file1 = document.getElementById('file1').files[0]
        var file2 = document.getElementById('file2').files[0]
        var file3 = document.getElementById('file3').files[0]
        var file4 = document.getElementById('file4').files[0]
        var file5 = document.getElementById('file5').files[0]
        var file6 = document.getElementById('file6').files[0]
        if (file1 !== undefined) {
          formData.append('file1', file1)
        }
        if (file2 !== undefined) {
          formData.append('file2', file2)
        }
        if (file3 !== undefined) {
          formData.append('file3', file3)
        }
        if (file4 !== undefined) {
          formData.append('file4', file4)
        }
        if (file5 !== undefined) {
          formData.append('file5', file5)
        }
        if (file6 !== undefined) {
          formData.append('file6', file6)
        }
        this.$store.state.isLoading = true
        emailService.scheduleEmailDashboardMail(token, formData).then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            _this.$store.state.isLoading = false
            store.state.scheduledDashboardEmailList.push(responseObj.data)
            _this.showAlertDialog = true
            _this.errorMsg = 'Given Report has been scheduled successfully.'
            _this.sendOrScheduledEmailSuccessfully = true
          } else {
            _this.sendOrScheduledEmailSuccessfully = false
            _this.showAlertDialog = true
            _this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          _this.$store.state.isLoading = false
          _this.sendOrScheduledEmailSuccessfully = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
      }
    },
    clearAllFields: function () {
      this.sendOrScheduledEmailSuccessfully = false
      this.showAlertDialog = false
      this.errorMsg = ''
      this.showSpinner = false
      this.userList = []
      this.groupList = []
      this.coursesList = []
      this.cohortList = []
      this.selectedGroupObj = -1
      this.selectedCourseObj = -1
      this.selectedCohortObj = -1
      this.showNoUserTxtInEnrolledUserBox = true
      this.showNoUserTxtInUnEnrolledUserBox = true
      this.isSelectedAllUnEnrolledUser = false
      this.isSelectedAllEnrolledUser = false
      this.selectedEnrolledUserIdArr = []
      this.selectedUnEnrolledUserIdArr = []
      this.selectedGCCUArr = []
      this.senderObj = {
        Name: '',
        Email: ''
      }
      this.toEmailObj = {
        Name: '',
        Email: ''
      }
      this.ccEmailObj = {
        Name: '',
        Email: ''
      }
      this.bccEmailObj = {
        Name: '',
        Email: ''
      }
      this.toEmailsArr = []
      this.ccEmailArr = []
      this.bccEmailArr = []
      this.selectedCourseIds = []
      this.selectedUserIds = []
      this.senderEmails = []
      this.selectedEmailTemplate = -1
      this.templateBodyText = 'Template Not Selected'
      this.prefixTemplateString = 'Are you sure you want to delete '
      this.postTemplateString = ''
      this.showConfirmationBox = false
      this.showAddTemplateOverlay = false
      this.showUpdateTemplateOverlay = false
      document.getElementById('file1').value = ''
      document.getElementById('file2').value = ''
      document.getElementById('file3').value = ''
      document.getElementById('file4').value = ''
      document.getElementById('file5').value = ''
      document.getElementById('file6').value = ''
      this.previewDashboardTemplateBeforeSendOrSchedule = false
      this.originalDashboardEmailTemplateResp = null
      this.sendOrScheduledEmailSuccessfully = false
      this.wantToScheduleEmail = false
      this.scheduleStartTS = new Date()
      this.scheduleEndTS = new Date()
      this.scheduleReportFrequency = -1
      this.config = {
        format: 'MM/DD/YYYY h:mm:ss A',
        defaultDate: new Date(),
        useCurrent: true,
        sideBySide: true
      }
      this.scheduleEmailDesc = ''
      this.getCurrentTemplateList()
      this.getGroups()
    }
  },
  name: 'immidiate-dashboard-email'
}
</script>

<style scoped>
.padding-2Perc {
  padding: 2%;
}
.border-1px-solid-grey {
  border: 1px dotted #aaa;
}
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.text-color-green {
  color: green;
  background: white;
  border-radius: 50%;
  border: 1px solid gainsboro;
  padding: 5px;
}
.text-color-red {
  color: red;
}
.margin-bottom-10px {
  margin-bottom: 10px;
}
.immidiate-dashboard-email {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.overflow-y-enabled{
  overflow-y: auto
}
.leftAlign{
  text-align: left;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.text-align-center {
  text-align: center !important;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.text-align-left {
  text-align: left !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-left-5perc {
  margin-left: 5%;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-1perc {
  margin-top: 1%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-1Perc {
  width: 1% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold {
  font-weight: bold;
}
.font-weight-bold-withOpacity75 {
  font-weight: bold;
  opacity: .75;
}

.font-size-15px {
  font-size: 15px;
}
.alignCenter{
  align: center;
}
.margin-0-auto{
  margin: 0 auto !important;
}
.border-color-yellow{
  border:1px solid yellow;
}
.align-center{
  align:center !important;
}
.demo-margin-left-1Perc{
  margin-left:1% !important;
}
.border-grey{
  border:1px solid grey;
}
.padding-left-1Perc{
  padding-left:1%;
}
.padding-left-12Perc{
  padding-left:12%;
}
.border-1px{
  border: 1px solid #ccc;
}
.padding-15px{
  padding:15px;
}
.width-90Perc{
  width: 90% !important;
}
.margin-bottom-7Perc{
  margin-bottom: 7%;
}
.margin-bottom-5Perc{
  margin-bottom: 5%;
}
.text-align-right{
text-align: right;
}
.padding-left-0Perc{
 padding-left:0%; 
}
.button-orange{
    background-color: #f39c12 !important;
    border: 1px solid #f39c12 !important;
}
.padding-top-7px{
  padding-top: 7px;
}
.floatLeft {
  float: left;
}
.cursor-pointer{
  cursor: pointer;
}
.padding-top-10px {
  padding-top: 10px;
}
.font-weight-normal {
  font-weight: normal
}
.Padding-right-0px {
  padding-right: 0px !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.text-align-left{
    text-align: left !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-top-5px{
  margin-top: 5px;
}
.border-red {
  border: 1px solid red;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.padding-left-0px {
  padding-left: 0px;
}
.padding-right-0px {
  padding-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/emails/dashboard_emails/ImmidiateOrScheduleDashboardEmail.vue